import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Batches.css";
import "../styles/Buttons.css";
import { formatDateForDisplay } from "../utils/dateUtils";
import CopyToClipboardButton from "../components/CopyToClipboardButton"; 

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const BatchCard = ({ batch, onDelete }) => {
  const navigate = useNavigate();

  // delte batch
  const handleDelete = async () => {
    if (
      window.confirm(`Are you sure you want to delete batch ${batch.batch_no}?`)
    ) {
      try {
        await axios.delete(
          `${API_BASE_URL}/api/admin/delete-batch/${batch.batch_no}`
        );
        onDelete(batch.batch_no); 
        alert("Batch deleted successfully!");
      } catch (error) {
        alert(
          "Error deleting batch: " +
            (error.response?.data?.error || "Unknown error")
        );
      }
    }
  };

  // create URL
  const batchUrl = batch.batch_qr_code
    ? `https://traceability.nzpuredairy.co.nz/batch?code=${batch.batch_qr_code}`
    : "";

  return (
    <div className="admin-batch-card">
      <div className="batch-details">
        <p>
          <strong>Batch No:</strong> {batch.batch_no}
        </p>
        <p>
          <strong>Product Code:</strong> {batch.product_code}
        </p>
        <p>
          <strong>Manufacture Date:</strong>{" "}
          {formatDateForDisplay(batch.manufacture_date)}
        </p>
        <p>
          <strong>Expiry Date:</strong>{" "}
          {formatDateForDisplay(batch.expiry_date)}
        </p>
        <p>
          <strong>QR Code Data:</strong> {batch.batch_qr_code}
        </p>
      </div>

      <div className="button-group">
        {/* COPY URL BUTTON */}
        <CopyToClipboardButton text={batchUrl} label="Copy URL" />
        <button
          className="edit-button"
          onClick={() => navigate(`/admin/edit-batch/${batch.batch_no}`)}
        >
          Edit Batch
        </button>

        <button className="delete-button" onClick={handleDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default BatchCard;
